import React from 'react';

const StatsBar = ({ stats, size = 'normal' }) => {
  const { total, uploaded, approved, needsAttention } = stats;
  const pending = uploaded - approved - (needsAttention || 0);
  
  // Build a simple text summary
  const parts = [`${approved} of ${total} approved`];
  if (needsAttention > 0) {
    parts.push(`${needsAttention} need${needsAttention === 1 ? 's' : ''} attention`);
  }
  
  return (
    <div className={`stats-bar ${size === 'small' ? 'stats-bar-small' : ''}`}>
      <div className="stats-bar-text">
        {parts.join(' · ')}
      </div>
      <div className="stats-bar-progress">
        <div 
          className="stats-bar-progress-approved" 
          style={{ width: `${(approved / total) * 100}%` }}
        />
        {pending > 0 && (
          <div 
            className="stats-bar-progress-pending" 
            style={{ 
              width: `${(pending / total) * 100}%`,
              left: `${(approved / total) * 100}%`
            }}
          />
        )}
        {needsAttention > 0 && (
          <div 
            className="stats-bar-progress-attention" 
            style={{ 
              width: `${(needsAttention / total) * 100}%`,
              left: `${((approved + pending) / total) * 100}%`
            }}
          />
        )}
      </div>
    </div>
  );
};

export default StatsBar;
